import { render } from "micromustache";
import { PropertyConfig } from "../../../forms/propertyConfig";
import { ValidationError } from "../../../forms/validationError";
import { anyObject, anyReallyAny, getProp } from "../../../tools/any.tools";
import { ERROR_MESSAGES, FALLBACK_ERROR_MESSAGE } from "../validation.i18n";
import { RegisterValidator, Validator } from "./validator";

export const MIN_LENGTH_VALIDATOR_NAME = "minLength";

/**
 * This validator ensures a string respects a minimum length
 * ! If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
 * sample use in propertyConfig => validators: validatorEntry(MinLengthValidator, 15) or validators: { minLength: 15 } (second option requires this class to be loaded)
 */
@RegisterValidator("minLength")
export class MinLengthValidator implements Validator<string, number> {

    /**
     * @returns true if propertyValue.length >= minLength
     */
    public isValid(property: PropertyConfig, propertyValue: string, minLength: number, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (propertyValue == null || propertyValue === "") {
            // If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
            return true;
        }
        return String(propertyValue).length >= minLength;
    }


    /** Get error message of validator */
    public getError?(lang: string, property: PropertyConfig, propertyValue: anyReallyAny, validatorParams: number, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, anyReallyAny>): ValidationError {
        const errorMessage = getProp<anyObject>(ERROR_MESSAGES, lang)[MIN_LENGTH_VALIDATOR_NAME] ?? getProp<anyObject>(ERROR_MESSAGES, lang)[FALLBACK_ERROR_MESSAGE];

        return { errorMessage: render(errorMessage, { propLabel: property.label, validatorParams: validatorParams }) };

    }
}